import { useState, useEffect } from 'react';
import { Address, ResultsParser, SmartContract, AbiRegistry } from '@multiversx/sdk-core/out';
import { networkProvider } from 'src/utils/networkProvider';
import json from 'src/contracts/tada-staking.json';
import { handleUnexpectedException } from 'src/helpers/functions';
import BigNumber from 'bignumber.js';

function useUserStakingHistory(userAddress, poolAddress) {
    const [userEntries, setUserEntries] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchUserEntries = async () => {
            try {
                const resultParser = new ResultsParser();
                const abi = AbiRegistry.create(json);
                const smartContract = new SmartContract({
                    address: new Address(poolAddress),
                    abi,
                });
                const interaction = smartContract.methods.getEntryForUser([new Address(userAddress)]);
                const query = interaction.check().buildQuery();
                const queryResponse = await networkProvider.queryContract(query);
                const returnData = resultParser.parseQueryResponse(queryResponse, interaction.getEndpoint());

                if (returnData && returnData.values && returnData.values.length > 0) {
                    const parsedEntries = returnData.values[0].items.map((item) => {
                        const stakeAmountValue = item.fields.find((field) => field.name === 'stake_amount').value;
                        const stakeAmount = new BigNumber(stakeAmountValue);
                        const unbondEpochValue = item.fields.find((field) => field.name === 'unbond_epoch').value;
                        const unbondEpoch = new BigNumber(unbondEpochValue);

                        return {
                            stakeAmount,
                            unbondEpoch: unbondEpoch.toString(),
                        };
                    });

                    setUserEntries(parsedEntries);
                }
            } catch (err) {
                handleUnexpectedException(err);
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        if (userAddress && poolAddress) {
            fetchUserEntries();
        }
    }, [userAddress, poolAddress]);

    return { userEntries, loading, error };
}

export default useUserStakingHistory;
